export const TimeBuffers = {
	pauseBufferTime: 10, //in seconds
	switchBufferTime: 10, //in seconds
};
